import { Subject } from 'rxjs/Rx';
import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable()
export class SocketListener {
  public subject = new Subject();
  @Output() onMessageReceived: EventEmitter<any> = new EventEmitter();
  @Output() onStatusReceived: EventEmitter<any> = new EventEmitter();
  @Output() onReLogin: EventEmitter<any> = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/app/layout/header/socket.listener.ts